import React, { useState, useEffect } from 'react'
import DataTable from '../Shared/DataTable/DataTable.js'
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import ItemDetailsPane from './ItemDetailsPane.js'
import AddItemPopup from './AddItemPopup.js'
import RemoveItemPopup from './RemoveItemPopup.js'
import Categories from './Categories.js'
import Menu from './Menu.js'
import AddButton from './AddButton.js'
import { ENTITYTYPES }  from '../Shared/EntityTypeIds.js';

const SystematicReviews = () => {

    let pageIcon = "fas fa-file-contract";
    let pageTitle = "Systematic Reviews";
    switch (window.srArea) {
        case 0: pageTitle += ": All Systematic Reviews"; break;
        case 1: pageTitle += ": Literature"; break;
        case 2: pageTitle += ": Regulatory News"; break;
        case 3: pageTitle += ": Market"; break;
        case 4: pageTitle += ": PMS"; break;
        default: break;
    }

    if (window.srProjectIdFilter != null) {
        pageTitle = "SR Group: " + window.srProjectName;
        pageIcon = "fas fa-layer-group";
    }

    let dataTableStructure = {};

    dataTableStructure.dataUrl = "/umbraco/api/SystematicReviewApi/SystematicReviews";
    dataTableStructure.getSingleItemUrl = "/umbraco/api/SystematicReviewApi/SystematicReview";
    dataTableStructure.pageTitle = pageTitle;
    dataTableStructure.singleItemTitle = "Systematic Review";
    dataTableStructure.entityType = "systematic-review";
    dataTableStructure.entityTypeId = ENTITYTYPES.SystematicReview;
    dataTableStructure.pageIcon = pageIcon;


    if (window.srProjectIdFilter != null)
        dataTableStructure.breadcrumbs = [{ "Name": "SR Groups", "Link": window.srProjectPageUrl }, { "Name": window.srProjectName, "Link": null }];
    else
        dataTableStructure.breadcrumbs = [{ "Name": "Systematic Reviews", "Link": "/your-medboard/systematic-reviews-menu/?area=" + window.srArea }];


    dataTableStructure.dataStructure = [];
    dataTableStructure.showComplianceStatusFilter = false;
    dataTableStructure.exportUrl = "";
    dataTableStructure.showTotalAndFilteredCounts = false;
    dataTableStructure.ComplianceType = "";
    dataTableStructure.enableTags = true;
    dataTableStructure.hasLeftMenu = window.srProjectIdFilter == null ? true : false; // If only showing SRs from a project/sr group doesn't draw middle menu
    dataTableStructure.srArea = window.srArea;
    dataTableStructure.srSection = window.srSection;
    dataTableStructure.surveillanceGroupsNr = window.surveillanceGroupsNr;
    dataTableStructure.categories = Categories;
    dataTableStructure.menuUrl = "/umbraco/api/SystematicReviewApi/Sections?area=" + dataTableStructure.srArea;
    dataTableStructure.menu = Menu;
    dataTableStructure.notificationsUrl = "/umbraco/api/SystematicReviewApi/SystematicReviewNotification";
    dataTableStructure.categoriesUrl = "/umbraco/api/SystematicReviewApi/Sections";
    dataTableStructure.srAddButton = AddButton;
    dataTableStructure.srType = null;
    dataTableStructure.showSystematicReviewsCompanyUserFilter = true;
    dataTableStructure.LimitNumberOfSurveillances = window.LimitNumberOfSurveillances;
    dataTableStructure.NumberOfSurveillances = window.NumberOfSurveillances;
    dataTableStructure.srApiUrl = "/umbraco/api/SystematicReviewApi/";
    dataTableStructure.srProjectApiUrl = "/umbraco/api/SystematicReviewApi/";
    dataTableStructure.srProjectPageUrl = window.srProjectPageUrl;
    dataTableStructure.srProjectIdFilter = window.srProjectIdFilter;
    dataTableStructure.showRIMSFilter = true;
    dataTableStructure.datatableRowCellCustomClass = "datatable-row-cell-custom-class-systematic-reviews";
    //dataTableStructure.showTaskCount = true;


    let baseLinkUrl = "/your-medboard/systematic-reviews/";

    dataTableStructure.baseLinkUrlForSrs = baseLinkUrl;

    //dataTableStructure.dataStructure.push({ name: "", field: "Id", width: "20px", sortable: false, isSelectItemCheckbox: true });
    dataTableStructure.dataStructure.push({ name: "Name", field: "Title", width: "300px", sortable: true, renderWith: FieldTypes.SRListLink, isMultiField: ["Title", "Id", "Collaborators", "Private", "ResponsiblePerson", { baseLinkUrl: baseLinkUrl, currentUserId: window.currentUserId }] });
    dataTableStructure.dataStructure.push({ name: "Notif.", field: "NotificationId", width: "55px", sortable: true, renderWith: FieldTypes.FieldType_SRNotification, isMultiField: ["Id", "NotificationId", "Collaborators", "Private", "ResponsiblePerson", { currentUserId: window.currentUserId }] });
    dataTableStructure.dataStructure.push({ name: "Responsible", field: "ResponsiblePerson", width: "95px", sortable: true, renderWith: FieldTypes.FieldType_SRResponsiblePerson, isMultiField: ["ResponsiblePerson", { currentUserId: window.currentUserId },] });
    dataTableStructure.dataStructure.push({ name: "Pending", field: "Pending", width: "85px", sortable: true, renderWith: FieldTypes.FieldType_SRPendingItems });
    dataTableStructure.dataStructure.push({ name: "Last Modified", field: "LastModified", width: "115px", sortable: true, renderWith: FieldTypes.FieldType_DateList });
    dataTableStructure.dataStructure.push({ name: "Last Match", field: "MostRecentContent", width: "115px", sortable: true, renderWith: FieldTypes.FieldType_DateList });
    dataTableStructure.dataStructure.push({ name: "Type", field: "Type", width: "150px", sortable: true, renderWith: FieldTypes.FieldType_SRCategory, isMultiField: ["Type", { Categories: Categories }] });
    dataTableStructure.dataStructure.push({ name: "Review Mode", field: "Mode", width: "105px", sortable: true, renderWith: FieldTypes.FieldType_SRReviewMode, isMultiField: ["Mode", "MostRecentContent"] });
    dataTableStructure.dataStructure.push({ name: "Tags", field: "Tags", width: "155px", sortable: true, renderWith: FieldTypes.FieldType_TagList });
    dataTableStructure.dataStructure.push({ name: "Actions", field: "Id", width: "95px", sortable: false, renderWith: FieldTypes.FieldType_SRItemMenu, isMultiField: ["Id", "NotificationId", "Collaborators", "Private", "ResponsiblePerson", { currentUserId: window.currentUserId }] });

    dataTableStructure.dataUrlParameters = { search: null, page: 1, orderByField: "LastModified", orderByType: "DESCENDING" }

    const customLoadItemDetails = (selectedFilterSystematicReviewsSection, itemId) => {

        let linkUrl = baseLinkUrl + selectedFilterSystematicReviewsSection + "/" + itemId + "/";
        window.location = linkUrl;
    }


    dataTableStructure.customLoadItemDetails = customLoadItemDetails;

    return (<>

        <DataTable dataTableStructure={dataTableStructure} ItemDetailsPane={null} AddItemPopup={AddItemPopup} RemoveItemPopup={RemoveItemPopup} ItemDetailsPane={ItemDetailsPane} />

    </>);

};






export default SystematicReviews;